function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import CropperElement from '@cropper/element';
import { CROPPER_VIEWER, getRootDocument, CROPPER_SELECTION, isElement, on, EVENT_CHANGE, CROPPER_CANVAS, CROPPER_IMAGE, EVENT_LOAD, EVENT_TRANSFORM, off } from '@cropper/utils';
var style = ":host{display:block;height:100%;overflow:hidden;position:relative;width:100%}";
var canvasCache = new WeakMap();
var imageCache = new WeakMap();
var selectionCache = new WeakMap();
var sourceImageCache = new WeakMap();
var RESIZE_BOTH = 'both';
var RESIZE_HORIZONTAL = 'horizontal';
var RESIZE_VERTICAL = 'vertical';
var RESIZE_NONE = 'none';

var CropperViewer = /*#__PURE__*/function (_CropperElement) {
  _inherits(CropperViewer, _CropperElement);

  var _super = _createSuper(CropperViewer);

  function CropperViewer() {
    var _this;

    _classCallCheck(this, CropperViewer);

    _this = _super.apply(this, arguments);
    _this.$onSelectionChange = null;
    _this.$onSourceImageLoad = null;
    _this.$onSourceImageTransform = null;
    _this.$scale = 1;
    _this.$style = style;
    _this.resize = RESIZE_VERTICAL;
    _this.selection = '';
    _this.slottable = false;
    return _this;
  }

  _createClass(CropperViewer, [{
    key: "$image",
    get: function get() {
      return imageCache.get(this);
    },
    set: function set(element) {
      imageCache.set(this, element);
    }
  }, {
    key: "$sourceImage",
    get: function get() {
      return sourceImageCache.get(this);
    },
    set: function set(element) {
      sourceImageCache.set(this, element);
    }
  }, {
    key: "$canvas",
    get: function get() {
      return canvasCache.get(this);
    },
    set: function set(element) {
      canvasCache.set(this, element);
    }
  }, {
    key: "$selection",
    get: function get() {
      return selectionCache.get(this);
    },
    set: function set(element) {
      selectionCache.set(this, element);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _a, _b;

      _get(_getPrototypeOf(CropperViewer.prototype), "connectedCallback", this).call(this);

      var $selection = null;

      if (this.selection) {
        $selection = (_b = (_a = getRootDocument(this)) === null || _a === void 0 ? void 0 : _a.querySelector(this.selection)) !== null && _b !== void 0 ? _b : null;
      } else {
        $selection = this.closest(this.$getTagNameOf(CROPPER_SELECTION));
      }

      if (isElement($selection)) {
        this.$selection = $selection;
        this.$onSelectionChange = this.$handleSelectionChange.bind(this);
        on($selection, EVENT_CHANGE, this.$onSelectionChange);
        var $canvas = $selection.closest(this.$getTagNameOf(CROPPER_CANVAS));

        if ($canvas) {
          this.$canvas = $canvas;
          var $sourceImage = $canvas.querySelector(this.$getTagNameOf(CROPPER_IMAGE));

          if ($sourceImage) {
            this.$sourceImage = $sourceImage;
            this.$image = $sourceImage.cloneNode(true);
            this.$getShadowRoot().appendChild(this.$image);
            this.$onSourceImageLoad = this.$handleSourceImageLoad.bind(this);
            this.$onSourceImageTransform = this.$handleSourceImageTransform.bind(this);
            on($sourceImage.$image, EVENT_LOAD, this.$onSourceImageLoad);
            on($sourceImage, EVENT_TRANSFORM, this.$onSourceImageTransform);
          }
        }

        this.$render();
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var $selection = this.$selection,
          $sourceImage = this.$sourceImage;

      if ($selection && this.$onSelectionChange) {
        off($selection, EVENT_CHANGE, this.$onSelectionChange);
        this.$onSelectionChange = null;
      }

      if ($sourceImage && this.$onSourceImageLoad) {
        off($sourceImage.$image, EVENT_LOAD, this.$onSourceImageLoad);
        this.$onSourceImageLoad = null;
      }

      if ($sourceImage && this.$onSourceImageTransform) {
        off($sourceImage, EVENT_TRANSFORM, this.$onSourceImageTransform);
        this.$onSourceImageTransform = null;
      }

      _get(_getPrototypeOf(CropperViewer.prototype), "disconnectedCallback", this).call(this);
    }
  }, {
    key: "$handleSelectionChange",
    value: function $handleSelectionChange(event) {
      this.$render(event.defaultPrevented ? this.$selection : event.detail);
    }
  }, {
    key: "$handleSourceImageLoad",
    value: function $handleSourceImageLoad() {
      var _this2 = this;

      var $image = this.$image,
          $sourceImage = this.$sourceImage;
      var oldSrc = $image.getAttribute('src');
      var newSrc = $sourceImage.getAttribute('src');

      if (newSrc && newSrc !== oldSrc) {
        $image.setAttribute('src', newSrc);
        $image.$ready(function () {
          _this2.$render();
        });
      }
    }
  }, {
    key: "$handleSourceImageTransform",
    value: function $handleSourceImageTransform(event) {
      this.$render(undefined, event.detail.matrix);
    }
  }, {
    key: "$render",
    value: function $render(selection, matrix) {
      var _this3 = this;

      var $canvas = this.$canvas,
          $selection = this.$selection;

      if (!selection && !$selection.hidden) {
        selection = $selection;
      }

      if (!selection || selection.x === 0 && selection.y === 0 && selection.width === 0 && selection.height === 0) {
        selection = {
          x: 0,
          y: 0,
          width: $canvas.offsetWidth,
          height: $canvas.offsetHeight
        };
      }

      var _selection = selection,
          x = _selection.x,
          y = _selection.y,
          width = _selection.width,
          height = _selection.height;
      var styles = {};
      var clientWidth = this.clientWidth,
          clientHeight = this.clientHeight;
      var newWidth = clientWidth;
      var newHeight = clientHeight;
      var scale = NaN;

      switch (this.resize) {
        case RESIZE_BOTH:
          scale = 1;
          newWidth = width;
          newHeight = height;
          styles.width = width;
          styles.height = height;
          break;

        case RESIZE_HORIZONTAL:
          scale = height > 0 ? clientHeight / height : 0;
          newWidth = width * scale;
          styles.width = newWidth;
          break;

        case RESIZE_VERTICAL:
          scale = width > 0 ? clientWidth / width : 0;
          newHeight = height * scale;
          styles.height = newHeight;
          break;

        case RESIZE_NONE:
        default:
          if (clientWidth > 0) {
            scale = width > 0 ? clientWidth / width : 0;
          } else if (clientHeight > 0) {
            scale = height > 0 ? clientHeight / height : 0;
          }

      }

      this.$scale = scale;
      this.$setStyles(styles);

      if (this.$sourceImage) {
        // Transform the image by the selection offset after the next DOM update cycle
        setTimeout(function () {
          _this3.$transformImageByOffset(matrix !== null && matrix !== void 0 ? matrix : _this3.$sourceImage.$getTransform(), -x, -y);
        });
      }
    }
  }, {
    key: "$transformImageByOffset",
    value: function $transformImageByOffset(matrix, x, y) {
      var _this4 = this;

      var $image = this.$image,
          $scale = this.$scale,
          $sourceImage = this.$sourceImage;

      if ($sourceImage && $image && $scale >= 0) {
        var _matrix = _slicedToArray(matrix, 6),
            a = _matrix[0],
            b = _matrix[1],
            c = _matrix[2],
            d = _matrix[3],
            e = _matrix[4],
            f = _matrix[5];

        var translateX = (x * d - c * y) / (a * d - c * b);
        var translateY = (y * a - b * x) / (a * d - c * b);
        var newE = a * translateX + c * translateY + e;
        var newF = b * translateX + d * translateY + f;
        $image.$ready(function (image) {
          _this4.$setStyles.call($image, {
            width: image.naturalWidth * $scale,
            height: image.naturalHeight * $scale
          });
        });
        $image.$setTransform(a, b, c, d, newE * $scale, newF * $scale);
      }
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return _get(_getPrototypeOf(CropperViewer), "observedAttributes", this).concat(['resize', 'selection']);
    }
  }]);

  return CropperViewer;
}(CropperElement);

CropperViewer.$name = CROPPER_VIEWER;
CropperViewer.$version = '2.1.0';
export { RESIZE_BOTH, RESIZE_HORIZONTAL, RESIZE_NONE, RESIZE_VERTICAL, CropperViewer as default };